'use client';

import { useEffect } from 'react';

import styles from './error.module.css';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.errorCode}>500</div>
          <h1 className={styles.title}>Something Went Wrong</h1>
          <p className={styles.description}>
            An unexpected error occurred. Please try again or contact support if the problem persists.
          </p>
          <div className={styles.actions}>
            <button onClick={reset} className={styles.retryButton}>
              Try Again
            </button>
            <a href="/" className={styles.homeButton}>
              Go to Homepage
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
